import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 4233.32 4233.32"
    {...props}
  >
    <path
      d="m3527.67 16817.48-23.94 23.96c-6.61-6.61-6.62-17.35-.01-23.96 6.61-6.61 17.34-6.61 23.95 0zm169.33 169.33.01 23.96h-23.95l-169.33-169.33 23.94-23.96 169.33 169.33zm-23.94 23.96 23.94-23.96c6.61 6.61 6.62 17.35.01 23.96-6.61 6.61-17.34 6.61-23.95 0zm-145.38 169.34-23.96-23.96 169.33-169.34 23.96 23.96-169.33 169.34zm-23.96-23.96 23.96 23.96c-6.61 6.61-17.34 6.61-23.95 0-6.61-6.61-6.62-17.35-.01-23.96z"
      className="fil0"
    />
    <path
      d="M3685.02 17015.72v-33.86c9.35 0 16.93 7.58 16.93 16.93s-7.58 16.93-16.93 16.93zm-338.66 0v-33.86h338.66v33.86h-338.66zm0-33.86v33.86c-9.35 0-16.93-7.58-16.93-16.93s7.58-16.93 16.93-16.93zM1980.75 328.46c-75.11-75.11-75.11-196.93 0-272.04 75.11-75.12 196.93-75.12 272.05 0l1920.81 1920.92c39.43 39.43 59.66 86.48 59.66 139.32 0 53.75-20.68 100.34-59.66 139.32L2252.8 4177.02c-75.12 75.11-196.94 75.11-272.05 0-75.11-75.12-75.11-196.94 0-272.05l1595.81-1595.92H192.44C86.19 2309.05.05 2222.91.05 2116.66c0-106.25 86.14-192.39 192.39-192.39h3384.12L1980.75 328.46z"
      className="fil0"
    />
  </svg>
);
export default SvgArrowLeft;
